import { Divider } from '@mui/joy';
import { SyntheticEvent, useEffect, useState } from 'react';
import { UseFormReset } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { ExternalSupplierInfo } from 'contacts/components';
import { VendorLocationFormField } from 'contacts/elements';
import {
  IContactGroupAddress,
  ISupplier,
  ISupplierPrimaryContact,
  ISupplierPurchasingAttribute,
} from 'contacts/types';
import { Form, FormField } from 'core/components';
import { InputType } from 'core/enums';
import { useFormContext } from 'core/states';
import { IAutocompleteOption } from 'core/types';

import { CorporatePartAssignVendorFormData } from './types';

interface IProps {
  isOpen: boolean;
  onSubmit: (
    reset?: UseFormReset<CorporatePartAssignVendorFormData>
  ) => (data: CorporatePartAssignVendorFormData) => void;
  onClose: (
    reset?: UseFormReset<CorporatePartAssignVendorFormData>,
    closeSelection?: boolean
  ) => void;
  externalSupplier?: Partial<ISupplier>;
  disabled?: boolean;
  interactive?: boolean;
  level?: number;
}

export const AlternateCorporatePartAssignVendorFormFields = ({
  isOpen,
  onSubmit,
  onClose,
  externalSupplier = null,
  disabled = false,
  interactive,
  level,
}: IProps) => {
  const [primaryContact, setPrimaryContact] = useState<ISupplierPrimaryContact | null>(null);
  const [purchasingAttributes, setPurchasingAttributes] = useState<
    (ISupplierPurchasingAttribute | null)[]
  >([]);

  const { t } = useTranslation();

  const { setValue } = useFormContext();

  useEffect(() => {
    setPrimaryContact(externalSupplier?.primaryContact);
    setPurchasingAttributes(externalSupplier?.purchasingAttributes);
  }, [externalSupplier]);

  const onChangeVendorLocation = (_: SyntheticEvent, option: IAutocompleteOption) => {
    const contactGroupAddress = option as unknown as IContactGroupAddress;

    setValue('vendorId', contactGroupAddress?.contactGroup?.alternateVendorId);
    setValue('vendorName', contactGroupAddress?.name);
    setValue('accountsPayableId', contactGroupAddress?.accountsPayableId);

    setPrimaryContact(contactGroupAddress?.primaryContact);
    setPurchasingAttributes(contactGroupAddress?.purchasingAttributes);
  };

  return (
    <Form
      title={t('titleAssignVendor')}
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={onSubmit}
      disabledSubmit={disabled}
      interactive={interactive}
      level={level}
    >
      <VendorLocationFormField
        name="vendorLocation"
        label={t('labelVendor')}
        placeholder={t('labelVendor')}
        onChange={onChangeVendorLocation}
        disabled={disabled}
      />

      <Divider />

      <FormField
        name="vendorName"
        type={InputType.TEXT_INPUT}
        inputProps={{
          label: t('labelVendorName'),
          placeholder: t('labelVendorName'),
          disabled: true,
        }}
      />

      <FormField
        name="vendorId"
        type={InputType.TEXT_INPUT}
        inputProps={{
          label: t('labelSupplierNumber'),
          placeholder: t('labelSupplierNumber'),
          disabled: true,
        }}
      />

      <FormField
        name="accountsPayableId"
        type={InputType.TEXT_INPUT}
        inputProps={{
          label: t('labelAPNumber'),
          placeholder: t('labelAPNumber'),
          disabled: true,
        }}
      />

      <Divider />

      <ExternalSupplierInfo
        primaryContact={primaryContact}
        purchasingAttributes={purchasingAttributes}
      />
    </Form>
  );
};
